export default {
  id: 'CreateClassModal',
  code: 'CN',
  text: {
    'Create Class': '新增班级',
    'Edit Class': '编辑班级',
    'Class Name': '班级名称',
    'Billing Types': '学费标准',
    'Notify me overdue fee...': '欠费提醒时间',
    'Lesson Completion Rules': '课消规则',
    'Attending counts as completion': '签到算课消',
    'Absence (with reason) counts as completion': '请假算课消',
    'Absence (without reason) counts as completion': '缺课算课消',
    '{i} day in advance' : '课时剩余 {i} 天前提醒',
    '{i} lesson in advance': '课时剩余 {i} 节课前提醒',
    '{i} hour in advance': '课时剩余 {i} 小时前提醒',
    '{i} days in advance' : '课时剩余 {i} 天前提醒',
    '{i} lessons in advance': '课时剩余 {i} 节课前提醒',
    '{i} hours in advance': '课时剩余 {i} 小时前提醒',
    'Bill by term total price': '按每期总价收费',
    'Bill by lessons unit price': '按课次单价收费',
    'Bill by hours unit price': '按小时单价收费',
    'Total Price': '总价',
    'Unit Price': '单价',
    'Display finished lessons consumption': '按已上课次显示消耗',
    'Display finished hours consumption': '按已上小时数显示消耗',
    'Total consumption when make payment': '缴费时计为全部消耗消耗',
    'Tuition Consumption Display': '学费消耗显示',
  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/CreateClass/locale.js